/**
 * @generated SignedSource<<8368cc3f0e0f0bdbd2bb54494f062655>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NotificationCenter_RefetchUnreadCountOnNewNotificationQuery$variables = {};
export type NotificationCenter_RefetchUnreadCountOnNewNotificationQuery$data = {
  readonly viewer: {
    readonly notificationCenter: {
      readonly id: string;
      readonly otherNotificationCount: number;
      readonly unreadNotificationCount: number;
    } | null;
  };
};
export type NotificationCenter_RefetchUnreadCountOnNewNotificationQuery = {
  response: NotificationCenter_RefetchUnreadCountOnNewNotificationQuery$data;
  variables: NotificationCenter_RefetchUnreadCountOnNewNotificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationCenter",
  "kind": "LinkedField",
  "name": "notificationCenter",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadNotificationCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherNotificationCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationCenter_RefetchUnreadCountOnNewNotificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationCenter_RefetchUnreadCountOnNewNotificationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b93fec057c77c7ef20fe679ed83c0fcd",
    "id": null,
    "metadata": {},
    "name": "NotificationCenter_RefetchUnreadCountOnNewNotificationQuery",
    "operationKind": "query",
    "text": "query NotificationCenter_RefetchUnreadCountOnNewNotificationQuery {\n  viewer {\n    notificationCenter {\n      id\n      unreadNotificationCount\n      otherNotificationCount\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc28fa51f6cca9a12536334a960a4123";

export default node;
